import { useCallback, useEffect } from 'react';
import { ACSApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { addUserOrganizationPolicies } from '../../../store/slices/user-policies.slice';
import { dispatch } from '../../../store';

const useHttpGetUserPoliciesOMX = () => {
    const acsApi: ACSApi = useContainer(ACSApi);

    const exec = useCallback(() => {
        const { exec } = acsApi.getUserPolicies({
            onSuccess: res => dispatch(addUserOrganizationPolicies(res.body)),
            onError: error => console.error(error),
        });
        exec();
    }, [acsApi]);

    useEffect(() => {
        exec();
    }, [exec]);

    return exec;
};

export default useHttpGetUserPoliciesOMX;
